module.exports = __webpack_public_path__ + "static/nozbe-95c84d5aa330c982758972d233ef3a59.svg";